import React from 'react';
import { Multiselect } from 'fw/forms';
import * as API from 'modules/app/API'

class RoleMultiselect extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { ...this.initialState(), loading: true }
    }

    initialState = () => {
    }

    componentDidMount = () => {
        this.loadRoles(this.props.userTypeCode);
    }

    loadRoles = (userTypeCode) => {
        let rq = {
            userTypeCode: userTypeCode
        };

        API.Security.get('/query/getRoles', rq,
            {
                success: (r) => {
                    this.setState({
                        loading: false,
                        items: r.data.items.map((item) => { return { label: item.roleName, value: item.roleId } })
                    });
                }
            });

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userTypeCode !== this.props.userTypeCode)
            this.loadRoles(nextProps.userTypeCode);
    }

    render() {
        if (this.state.loading)
            return null;

        return (
            <Multiselect
                {...this.props}
                items={this.state.items} />
        )
    }
}

export default RoleMultiselect;

// Mark this as a form component
RoleMultiselect.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/roleMultiselect/RoleMultiselect.js